module.exports = __webpack_public_path__ + "static/media/Main_Photo.d3fadbb3.jpg";